import { useEffect, useRef } from "react";

/**
 * Reports an error state to a parent callback without causing re-renders.
 * Uses a ref for the callback to keep it out of the useEffect dependency array.
 *
 * @param hasError - Whether an error condition is active
 * @param onError - Optional callback to invoke when hasError becomes true
 */
export const useReportError = (hasError: boolean, onError?: () => void) => {
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    useEffect(() => {
        if (hasError) {
            onErrorRef.current?.();
        }
    }, [hasError]);
};
